import React from "react";
import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, subtitle, image }) {
  const bg =
    image ||
    "https://static.prod-images.emergentagent.com/jobs/f7c4b906-4127-46a6-93a6-9c0f67cd8c80/images/5627fe57c03e1b4dc7501c420135f988531ad1c41da21690028291a50c9ea1cb.png";
  return (
    <section
      data-testid="page-header"
      className="relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(15,76,58,0.92), rgba(15,76,58,0.6)), url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="heritage-pattern absolute inset-0" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          {eyebrow && (
            <div className="text-brand-secondary text-xs tracking-[0.3em] uppercase mb-3">
              {eyebrow}
            </div>
          )}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-none">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-white/85 text-base sm:text-lg max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
